module.exports = __webpack_public_path__ + "static/progetto_gioiagarden1-cbf6a0033c99f782d75cab14af724868.jpg";